import { customOfferActionApi } from './api';
import * as log from './log';
import { CUSTOM_OFFER_TRANSITIONS } from './customOffers';

const LEGACY_CUSTOM_OFFER_CONFIRM_TRANSITIONS = [
  'transition/confirm-payment',
  'transition/operator-confirm-payment',
  'transition/confirm-pay-later-payment',
  'transition/operator-confirm-pay-later-payment',
];

export const isCustomOfferPaymentConfirmationTransition = transitionName =>
  [
    CUSTOM_OFFER_TRANSITIONS.CONFIRM_PAYMENT,
    CUSTOM_OFFER_TRANSITIONS.OPERATOR_CONFIRM_PAYMENT,
    CUSTOM_OFFER_TRANSITIONS.CONFIRM_PAY_LATER_PAYMENT,
    ...LEGACY_CUSTOM_OFFER_CONFIRM_TRANSITIONS,
  ].includes(transitionName);

const normalizeId = value => (typeof value === 'string' ? value : value?.uuid);

export const completeCustomOfferPaymentIfNeeded = async ({
  order,
  transactionId,
  transitionName,
}) => {
  const customOffer = order?.attributes?.protectedData?.customOffer;

  if (!customOffer?.id || !isCustomOfferPaymentConfirmationTransition(transitionName)) {
    return null;
  }

  const txId = normalizeId(order?.id) || normalizeId(transactionId);

  try {
    return await customOfferActionApi({
      transactionId: txId,
      offerId: customOffer.id,
      action: 'mark-paid',
    });
  } catch (e) {
    log.error(e, 'custom-offer-mark-paid-failed', {
      transactionId: txId,
      offerId: customOffer.id,
    });
    throw e;
  }
};
